<template>
    <RatingForm :rating="rating" v-if="loaded" :readOnly="false" />
</template>

<script>
import {BModal, BButton, VBModal, BCard, BCardText, BAvatar, BBadge, BPagination, BFormGroup, BFormInput, BFormSelect, BDropdown, BDropdownItem, } from 'bootstrap-vue'
import {APIRequest} from '@simb2s/senseye-sdk'
import { VueGoodTable } from 'vue-good-table'
import RatingForm from './RatingForm.vue'

export default {
  components: {
    BCard,
    BCardText,
    VueGoodTable,
    BAvatar,
    BBadge,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    BModal,
    BButton,
    RatingForm
  },
  data() {
    return {
      rating:null,
      loaded:false,
    }
  },
  methods:{
    
  },
  async mounted()
  {
    this.rating=await APIRequest.detail('reviews',this.$route.params.id)
    this.loaded=true
  }
}
</script>
